export interface IAMZDateStamp {
  amzDate: string;
  dateStamp: string;
}

export function getAmzDateStamp(): IAMZDateStamp {
  const now = new Date();
  const pad = (n: number): string => String(n).padStart(2, '0');
  const y = now.getUTCFullYear();
  const m = pad(now.getUTCMonth() + 1);
  const d = pad(now.getUTCDate());
  const hh = pad(now.getUTCHours());
  const mm = pad(now.getUTCMinutes());
  const ss = pad(now.getUTCSeconds());
  return {
    amzDate: `${y}${m}${d}T${hh}${mm}${ss}Z`,
    dateStamp: `${y}${m}${d}`,
  };
}
